import {Component, OnInit, ViewChild} from '@angular/core';
import {forkJoin} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthService, RecursiveHelper, User} from '@hassel-it/angular-common';
import {UsersService, CustomFieldsService} from '@hassel-it/angular-common';
import {NgForm} from '@angular/forms';
import {environment} from "../../environments/environment";

/**
 * LIVES IN ECOM PROJECT
 */

@Component({
    providers: [UsersService, CustomFieldsService],
    selector: 'app-user-edit',
    templateUrl: './user-edit.component.html',
    styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent implements OnInit {

    userForm: NgForm;
    @ViewChild('userForm') currentForm: NgForm;

    groups: Group[];
    user: User;
    saving = false;

    customFieldsPresetr = null;
    public permissions = [];

    constructor(
        public activatedRoute: ActivatedRoute,
        public router: Router,
        public authService: AuthService,
        private httpClient: HttpClient,
        public usersService: UsersService,
        public customFieldsService: CustomFieldsService,
    ) {
    }

    ngAfterViewChecked() {
        this.formChanged();
    }

    formChanged() {
        if (this.currentForm === this.userForm) {
            return;
        }
        this.userForm = this.currentForm;
        if (this.userForm) {
        }
    }

    getUser(userId) {
        if (!userId) {
            return Promise.resolve(User.fromJSON({
                name: null,
                id: null,
                username: null,
                password: null,
                group_id: null
            }));
        } else {
            return this.usersService.getUser(userId);
        }
    }

    ngOnInit() {
        this.activatedRoute.paramMap.subscribe(params => {
            const options = {
                headers: new HttpHeaders({
                    'Authorization': 'Bearer ' + this.authService.getToken(),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }),
            };
            forkJoin(
                this.httpClient.get(environment.apiBase + '/api/groups', options),
                this.getUser(params.get('userId')),
                this.usersService.getPermissions(),
                this.customFieldsService.getPresets({type: 'user'})
            ).subscribe(data => {
                const groups = <any>data[0];
                this.groups = groups.data;
                this.user = <User>data[1];
                this.customFieldsPresetr = data[3];
                this.permissions = data[2];
                if (!this.user.id) {
                    this.user.permissions = this.permissions;
                    this.user.custom_fields = this.customFieldsPresetr;
                }
            });
        });
    }

    save() {

        this.saving = true;

        const options = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + this.authService.getToken(),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }),
        };

        if (this.user.id) {
            this.httpClient.patch(environment.apiBase + '/api/admin/users/edit/' + this.user.id, this.user, options).subscribe((response: any) => {
                this.saving = false;
                this.router.navigateByUrl('/users');
            }, (errorResponse) => {
                RecursiveHelper.recursiveFunction(errorResponse.error.errors, (path, value, key) => {
                    const formGroup = this.userForm.form.get(path);
                    if (formGroup) {
                        formGroup.setErrors({invalid: value});
                    }
                });
                this.saving = false;
                alert('Could not save user')
            });
        } else {
            this.httpClient.post(environment.apiBase + '/api/admin/users/add', this.user, options).subscribe((response: any) => {
                this.saving = false;
                this.router.navigateByUrl('/users');
            }, (errorResponse) => {
                RecursiveHelper.recursiveFunction(errorResponse.error.errors, (path, value, key) => {
                    const formGroup = this.userForm.form.get(path);
                    if (formGroup) {
                        formGroup.setErrors({invalid: value});
                    }
                });
                this.saving = false;
                alert('Could not create user')
            });
        }
    }
}

export interface Group {
    id: number;
    name: string;
}
